import React from 'react';
import { Box, Flex, Icon, SimpleGrid, Text, useToast } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiInstagram, FiMail, FiMessageCircle, FiPhone } from 'react-icons/fi';
import { ff } from '../../../theme';
import { SALES_CONTACT } from '../constants';

const COPY_ACTIONS: { key: string; label: string; value: string; icon: IconType }[] = [
  { key: 'email', label: 'Email', value: SALES_CONTACT.email, icon: FiMail },
  { key: 'phone', label: 'Phone', value: SALES_CONTACT.phoneDisplay, icon: FiPhone },
  { key: 'whatsapp', label: 'WhatsApp', value: SALES_CONTACT.whatsappUrl, icon: FiMessageCircle },
  { key: 'instagram', label: 'Instagram', value: SALES_CONTACT.instagramUrl, icon: FiInstagram },
];

/** Lime card for the sales lead; each tile copies one way to reach them. */
const SalesContactCard: React.FC = () => {
  const toast = useToast();

  const copy = async (label: string, value: string) => {
    await navigator.clipboard.writeText(value);
    toast({ title: `${label} copied`, status: 'success', duration: 2000 });
  };

  return (
    <Box p="14px" borderRadius="18px" bg={ff.limeSurface}>
      <Flex align="center" gap="12px" mb="12px">
        <Flex flex="none" w="44px" h="44px" borderRadius="full" bg={ff.ink} color={ff.lime} align="center" justify="center" fontSize="16px" fontWeight={600}>
          {SALES_CONTACT.name.charAt(0)}
        </Flex>
        <Box>
          <Text fontSize="16px" fontWeight={600}>{SALES_CONTACT.name}</Text>
          <Text fontSize="13px" color="#3E3E42">{SALES_CONTACT.title} · your intro contact</Text>
        </Box>
      </Flex>
      <SimpleGrid columns={4} spacing="8px">
        {COPY_ACTIONS.map(action => (
          <Flex
            key={action.key}
            as="button"
            type="button"
            direction="column"
            align="center"
            justify="center"
            gap="3px"
            h="56px"
            borderRadius="14px"
            bg="white"
            color={ff.ink}
            fontSize="11px"
            fontWeight={600}
            aria-label={`Copy ${SALES_CONTACT.name.split(' ')[0]}'s ${action.label}`}
            onClick={() => void copy(action.label, action.value)}
          >
            <Icon as={action.icon} boxSize="18px" />
            {action.label}
          </Flex>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default SalesContactCard;
